import discardPiles from '@/store/modules/storage/rounds/discardPiles';
import melds from '@/store/modules/storage/rounds/melds';
import stockPiles from '@/store/modules/storage/rounds/stockPiles';

export default {
    discardPiles,
    melds,
    stockPiles,
};
